module.exports = "/assets/data/22fbc5f193579e433bb567d609bd5ed7-RG24.data.json";